import WorkflowList from './container';

export default WorkflowList;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkflowList/index.js